import PaginatedList from '@theme/paginated-list';
import { sectionRenderer } from '@theme/section-renderer';
import { FilterUpdateEvent } from '@theme/events';
import { startViewTransition } from '@theme/utilities';

/**
 * A custom element that renders a paginated blog posts list
 */
export default class BlogPostsList extends PaginatedList {
  /**
   * Handles tag filter clicks and re-renders the section without page reload.
   * @param {MouseEvent} event
   */
  handleTagClick(event) {
    if (!(event.target instanceof HTMLElement)) return;

    const button = event.target.closest('[data-filter-url]');
    if (!(button instanceof HTMLElement)) return;

    const urlValue = button.dataset.filterUrl;
    if (!urlValue) return;

    event.preventDefault();

    const nextUrl = new URL(urlValue, window.location.origin);

    history.pushState({}, '', nextUrl.toString());
    this.dispatchEvent(new FilterUpdateEvent(new URLSearchParams(nextUrl.search)));

    const viewTransition = !this.closest('dialog');
    if (viewTransition) {
      startViewTransition(() => sectionRenderer.renderSection(this.sectionId, { url: nextUrl }), ['blog-posts']);
    } else {
      sectionRenderer.renderSection(this.sectionId, { url: nextUrl });
    }
  }
}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}
